import CONFIG from '~/config'

export const setDismissedCardActivationSuccessModal = () => localStorage.setItem(CONFIG.COOKIE_DISMISSED_CARD_ACTIVATION_SUCCESS_MODAL, true)
export const getDismissedCardActivationSuccessModal = () => !!localStorage.getItem(CONFIG.COOKIE_DISMISSED_CARD_ACTIVATION_SUCCESS_MODAL)
